import { useEffect, useState } from 'react';
import { getWebsiteSettings, type WebsiteSettings } from '@/services/api/website-settings.service';

export function useWebsiteSettings() {
  const [settings, setSettings] = useState<WebsiteSettings | null>(null);

  useEffect(() => {
    let alive = true;
    getWebsiteSettings()
      .then((data) => {
        if (alive) setSettings(data);
      })
      .catch(() => undefined);

    return () => { alive = false; };
  }, []);

  return settings;
}
